
    export default {
        name: "MenuButton",
    }
